import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { BaseRoleEntity } from '@/features/baseRole/domain/entities/BaseRoleEntity'
import type { UserEntity } from '../../domain/entities/UserEntity'
import type { UserRolesEntity } from '../../domain/entities/UserRolesEntity'

export const useCurrentUserStore = defineStore('currentUserStore', () => {
  const userData = ref<UserEntity>()

  const allPolicies = ref<string[]>([])

  const userRoles = ref<BaseRoleEntity[] | null | undefined>()

  const allDataLoaded = ref(false)

  async function addCurrentUserData(data: UserEntity) {
    userData.value = data
  }
  async function addCurrentUserRoles(data: UserRolesEntity) {
    userRoles.value = Array.from(
      new Map(
        ([...(userRoles.value ?? []), ...(data.baseRoles ?? []), ...(data.roles ?? [])]
          .filter(role => role && role.id !== undefined)
          .map(role => [role.id, role])
        )
      ).values());
    userRoles?.value?.forEach((role) => {
      role.policies?.forEach((policy) => {
        if (allPolicies.value.includes(policy.name ?? '')) return
        allPolicies.value.push(policy.name ?? '')
      })
    })
  }
  async function addCurrentUserAuthRoles(data: UserRolesEntity) {
    userRoles.value = Array.from(
      new Map(
        ([...(userRoles.value ?? []), ...(data.baseRoles ?? []), ...(data.roles ?? [])]
          .filter(role => role && role.id !== undefined)
          .map(role => [role.id, role])
        )
      ).values());
    userRoles?.value?.forEach((role) => {
      role.policies?.forEach((policy) => {
        if (allPolicies.value.includes(policy.name ?? '')) return
        allPolicies.value.push(policy.name ?? '')
      })
    })
    allDataLoaded.value = true
  }

  return {
    userData,
    addCurrentUserData,
    addCurrentUserRoles,
    allPolicies,
    allDataLoaded,
    userRoles,
    addCurrentUserAuthRoles
  }
})
